import './scss/style.scss';

import nav from './components/nav/component.js';

import matching from './games/matching.js';
import billboard from './games/billboard.js';
import this_or_that from './games/this_or_that.js';
import what_should_you_do from './games/what_should_you_do.js';
import puzzle from './games/puzzle.js';
import roundabout from './games/roundabout.js';

import state from './state.js';

import audio from './components/audio.js';

const games = {
	matching:matching,
	billboard:billboard,
	this_or_that:this_or_that,
	what_should_you_do:what_should_you_do,
	puzzle:puzzle,
	roundabout:roundabout,
};

const container = document.createElement('div');
container.id='games_container';

container.appendChild(nav.view);

window.addEventListener('load',()=>{
	let game = window.location.search.split('&')[0].substr(1);

	if(game) window.__games.play(game);
});

const _close = (mode)=>{
	if(_game) games[_game].stop();

	if(_prev){
		_prev.style.display='';
		_prev.removeAttribute('aria-hidden');
	}
	document.body.removeChild(container);
	try{
		skin.player.setVariableValue('game_open',false);
		switch(mode){
			case 'map':
				skin.player.setVariableValue('vis_complex_popup',false);
			break;
			case 'skip':
				skin.player.setVariableValue('vis_complex_popup',true);
			break;
		}
	} catch (e){

	}
	try{
		window.dispatchEvent(new Event('resize'));
	} catch (e){

	}

	setTimeout(()=>{
		try{
			setFocusPopup();
		} catch(e){}
	},1000);

	container.childNodes.forEach(el=>{
		if(el!==nav.view) container.removeChild(el);
	});
};

nav.clb=_close;

let _prev;

let _game;

window.__games = {
	play:game=>{
		_game = game;
		_prev = document.querySelector('#container');

		if(_prev){
			_prev.style.display='none';
			_prev.setAttribute('aria-hidden','true');
		}

		document.body.appendChild(container);

		try{
			const car = skin.player.getVariableValue('car_selection');

			switch(car){
				case 'yellow':
					state.car = 1;
				break;
				case 'red':
					state.car = 2;
				break;
				case 'teal':
					state.car = 3;
				break;
				case 'blue':
					state.car = 4;
				break;
				case 'van':
					state.car = 5;
				break;
				case 'black':
					state.car = 6;
				break;
			}
		} catch(e){

		}

		nav.skip=games[game].played;
		games[game].start({container,clb:_close});
		games[game].played = true;
	}
}
